import api from './axiosConfig';
export const getUsers = async (params = {}) => {
    var _a, _b, _c, _d, _e, _f;
    const normalizedSearchTerm = (_b = (_a = params.searchTerm) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : '';
    const normalizedParams = {
        page: (_c = params.page) !== null && _c !== void 0 ? _c : 1,
        limit: (_d = params.limit) !== null && _d !== void 0 ? _d : 10,
        useYn: (_e = params.useYn) !== null && _e !== void 0 ? _e : '',
        searchColumn: normalizedSearchTerm ? (_f = params.searchColumn) !== null && _f !== void 0 ? _f : 'userId' : 'all',
        searchTerm: normalizedSearchTerm,
    };
    const response = await api.get('/api/users', { params: normalizedParams });
    return response.data;
};
export const getUserById = async (id) => {
    const response = await api.get(`/api/users/${id}`);
    return response.data;
};
export const createUser = async (userData) => {
    const response = await api.post('/api/users', userData);
    return response.data;
};
export const updateUser = async (id, userData) => {
    const response = await api.put(`/api/users/${id}`, userData);
    return response.data;
};
export const deleteUser = async (id) => {
    const response = await api.delete(`/api/users/${id}`);
    return response.data;
};
export const bulkCreateUsers = async (users) => {
    const response = await api.post('/api/users/bulk', { users });
    return response.data;
};
export const downloadUsersExcelTemplate = async () => {
    const response = await api.get('/api/users/template', {
        responseType: 'blob',
    });
    return response.data;
};
export const exportUsersToExcel = async (params) => {
    const response = await api.get('/api/users/export', {
        params,
        responseType: 'blob',
    });
    return response.data;
};
export const importUsersFromExcel = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/api/users/import', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
};
